import styled, { css } from 'styled-components';

export const MatchRowWrapper = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0.1em;
  min-height: 4em;
  width: 100%;
  padding: 0.5em 0;
  margin: ${props => (props.isHighlight ? '0px' : '0 auto 0.4em')};
  border-left-width: ${props => (props.isHighlight ? '0px' : '1px')};
  border-right-width: ${props => (props.isHighlight ? '0px' : '1px')};
  border-top-width: 1px;
  border-bottom-width: ${props => (props.isHighlight ? '0px' : '1px')};
  border-color: ${props => props.theme.colors.borderColor};
  border-style: solid;
  display: ${props => (props.hideMatch ? 'none' : 'flex')};
  &:hover {
    background: ${props => props.theme.colors.hoverColor};
    border-color: ${props => props.theme.colors.hoverBorderColor};
  };
  &.no-event{
    pointer-events: none;
    .icon-matchcenter-right-arrow{
      display: none;
    }
  };
`;

export const MatchStatsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin-left: 1em;
    flex-direction: column;
  }
`;

export const CyclingLabel = styled.div`
  color: ${props => props.theme.colors[props.color]};
  font-weight: ${props => props.weight};
  margin-left: ${props => props.marginLeft}em;
  text-align: left;
  ${props => (props.font) && css` 
  font-family: ${props.theme.fontSets[props.font]};
  font-size: 15px;
  `};
  ${props => props.theme.mediaQueries.small_phone}{
  font-size: 12px;
  }
`;
